'use strict';

function handleAttendeeSelection(isQuickView = false) {
    $('.attendees-container').each((_index, attendeeContainer) => {
        const $attendeeContainer = $(attendeeContainer);
        const $fileInput = $attendeeContainer.find('.file-input');
        const $textarea = $attendeeContainer.find('textarea');
        const $formControl = $attendeeContainer.find('.form-control');
        const $errorMessage = $attendeeContainer.find('.invalid-feedback');

        $fileInput.change(() => {
            $formControl.removeClass('is-invalid');
            $errorMessage.text('');

            const file = $fileInput[0].files[0];
            const reader = new FileReader();

            reader.onload = event => {
                const content = event.target.result;
                const attendees = content.replace(/\r/g, '').split('\n');
                const filteredAttendees = attendees.filter(attendee => attendee.trim().length > 0);
                const attendeesString = filteredAttendees.join(', ');
                $textarea.val(attendeesString);
            };

            reader.readAsText(file);
        });

        if (isQuickView) {
            const $button = $attendeeContainer.closest('.quick-view-dialog').find('.update-cart-product-global');
            if ($button.length > 0) {
                $button.attr('disabled', false);
                $button.off('mouseenter').on('mouseenter', () => {
                    const attendees = $attendeeContainer.find('textarea').val();
                    const attendeesArray = attendees ? attendees.split(',') : null;
                    const numAttendees = attendeesArray ? attendeesArray.length : 0;
                    $button.prev('.update-cart-url').data('quantity', numAttendees);
                });
            }
        }
    });
}

function handleEditModalLaunch() {
    $('body').on('quickview:ready', () => {
        handleAttendeeSelection(true);
    });
}

function validateAttendeeSelection(target) {
    const $productContainer = $(target).closest('.quick-view-dialog').length > 0
        ? $(target).closest('.quick-view-dialog').find('.product-detail')
        : $(target).closest('.product-detail');

    if ($productContainer.data('is-enrollment') === true) {
        let attendees = $productContainer.find('.attendees-container textarea').val();
        // if the last characters of attendees string are commas or semicolons, remove them
        if (attendees && /[,;]+$/.test(attendees)) {
            $productContainer.find('.attendees-container textarea').val(attendees.replace(/[,;]+$/, ''));
            attendees = $productContainer.find('.attendees-container textarea').val();
        }
        const attendeesArray = attendees ? attendees.split(',') : null;
        const $formControl = $productContainer.find('.attendees-container .form-control');
        const $errorMessage = $productContainer.find('.attendees-container .invalid-feedback');

        $formControl.removeClass('is-invalid');
        $errorMessage.text('');

        if (attendeesArray && attendeesArray.length > 0) {
            const invalidEmails = attendeesArray.filter(attendee => {
                const emailRegEx = /^[\w-\.+]+@([\w-]+\.)+[\w-]{2,4}$/;
                return !emailRegEx.test(attendee.trim());
            });

            if (invalidEmails.length > 0) {
                $errorMessage.text($errorMessage.data('invalid') + ' ' + invalidEmails.join(', '));
                $formControl.addClass('is-invalid');
                $.spinner().stop();
                return false;
            }
        } else {
            $errorMessage.text($errorMessage.data('missing'));
            $formControl.addClass('is-invalid');
            $.spinner().stop();
            return false;
        }
    }
    return true;
}

module.exports = {
    handleAttendeeSelection: handleAttendeeSelection,
    handleEditModalLaunch: handleEditModalLaunch,
    validateAttendeeSelection: validateAttendeeSelection
};
